import React from "react";
/** Components Import */
import Section from "../../Components/Section";
import Card from "../../Components/Card_wrap";
import AuthGroupButton from "../../Components/Button_Auth_Group";
import BasicButton from "../../Components/Button_Basic";
import Dialog from "../../Services/Common/Dialog";
import DatePicker from "../../Components/Datepicker_Basic";
import FormGroup from "../../Components/Form_Group";
import CardH3 from "../../Components/Card_H3";
import InputBasic from "../../Components/Input_Basic";
import GridModal from "../../Components/Modal_Grid";
import EmptyBox from "../../Components/EmptyBox";
import AgDatePicker from "../../Components/agGrid/ag-DatePicker";
import BasicArea from "../../Components/PDA/BarcodeArea";
/** Ag-grid Import */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import GridFunctions from "../../Services/agGrid/ag-Grid-functions";
import BasicCombo from "../../Components/Combo_Basic";
function ST10040(props) {
  React.useEffect(() => {
    document.title = "제품이동(PDA)";

    const element = document.getElementById("topbar");
    element.innerHTML =
      "<h1>" +
      "<span class='bullet'>" +
      "</span>" +
      "<strong class='depth-1'>" +
      "재고관리" +
      "	</strong>" +
      "<span class='divider' >" +
      "</span>" +
      "<strong'>제품이동(PDA)</strong>" +
      "</h1>";
  }, []);
  const [modalToggle2, setModalToggle2] = React.useState(false);
  const [selectedModalData2, setSelectedModalData2] = React.useState(null);
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  React.useEffect(() => {
    const HandleEnterKey = (e) => {
      const { key, keyCode } = e;
      if (keyCode === 13) {
        navigator.clipboard.readText().then((clipboardText) => {
          if (clipboardText.length === 12) {
            props.BarcodeScan(clipboardText, props.checkInputs2.whCd);
          } else {
            setSnackbars({
              toggle: true,
              type: "error",
              message: "Barcode번호를 확인해주세요",
            });
          }
        });
      }
    };
    window.addEventListener("keypress", HandleEnterKey);

    return () => window.removeEventListener("keypress", HandleEnterKey);
  });
  const gridRef = React.useRef();
  const autoGroupColumnDef = React.useMemo(() => {
    //그룹설정
    return {
      headerName: "품명",
      minWidth: 200,
    };
  }, []);
  const lotColumnDef = [
    {
      field: "no",
      headerName: "No",
      minWidth: 110,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      hide: true,
    },
    //LOT No
    {
      field: "lotNo",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_LotNo" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    //품목코드
    // {
    //   field: "itemCd",
    //   headerName:
    //     props.lanData.length > 0
    //       ? props.lanData.filter(
    //           (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
    //         )[0].lanName
    //       : "",
    // },
    //품목명
    {
      field: "itemNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      rowGroup: true,
      hide: true,
    },
    //수량
    {
      field: "stockQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemQty" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
    },
    //창고코드
    {
      field: "whCd2",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_WhNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      hide: true,
    },
    //창고
    {
      field: "whCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_WhNm" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
  ];
  return (
    <div>
      <EmptyBox />
      <BasicArea
        inputValue={props.inputs.barcodeValue}
        onInputChange={(e) => {
          props.setInputs({
            ...props.inputs,
            barcodeValue: e,
          });
        }}
        switchValue={props.inputs.switchValue}
        onSwitchChange={(e) => {
          props.setInputs({
            ...props.inputs,
            switchValue: e,
          });
        }}
        onInputKeyDown={(e) => {
          if (props.inputs.barcodeValue.length === 12) {
            props.BarcodeScan(
              props.inputs.barcodeValue,
              props.checkInputs2.whCd
            );
          } else {
            setSnackbars({
              toggle: true,
              type: "error",
              message: "Barcode번호를 확인해주세요",
            });
          }
        }}
        autoFocus={true}
      />
      <Card
        wrapStyle={{
          height: "15vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // textAlign: "space-between",
          alignItems: "flex-start",
        }}
      >
        {/* <BasicCombo
          name="조회 창고"
          combos={props.checkInputs.comboWhCd}
          value={props.checkInputs2.whCd}
          onChange={(e) => {
            props.setCheckInputs2({
              ...props.checkInputs2,
              whCd: e,
            });
          }}
        /> */}
        <BasicCombo
          name="이동 창고"
          combos={props.checkInputs.comboMoveWhCd}
          value={props.checkInputs2.moveWhCd}
          onChange={(e) => {
            props.setCheckInputs2({
              ...props.checkInputs2,
              moveWhCd: e,
            });
          }}
        />
      </Card>
      <Section />
      <div
        className="ag-theme-alpine no-scroll"
        style={{ width: "100%", height: "300px" }}
      >
        <AgGridReact
          ref={gridRef}
          animateRows={true}
          columnDefs={lotColumnDef}
          defaultColDef={{
            flex: 1,
            minWidth: 100,
            editable: false,
            resizable: true,
            sortable: true,
            filter: true,
            floatingFilter: true,
          }}
          autoGroupColumnDef={autoGroupColumnDef}
          rowData={props.stockData}
          // rowSelection="multiple"
          // onSelectionChanged={() =>
          //   GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData1)
          // }
          // suppressRowClickSelection={true}
          // onCellValueChanged={(e) =>
          //   GridFunctions.onCellValueChanged(
          //     e,
          //     gridRef,
          //     props.setChangedRowData1
          //   )
          // }
          // groupDefaultExpanded={1}
          // suppressAggFuncInHeader={true}
          enableCellChangeFlash={true}
          // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
        />
      </div>
      <Card
        wrapStyle={{
          height: "8vh",
          display: "flex",
          flexDirection: "row",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <BasicButton
          name={
            props.lanData.length > 0
              ? props.lanData.filter(
                  (f) => f.lanId === "Fom_MoveStock" && f.lanType === "FORM" //재고이동
                )[0].lanName
              : ""
          }
          onClick={(e) => {
            props.MoveWhCdStock(props.stockData);
          }}
        />
      </Card>
      {/* {modalToggle2 && (
        <GridModal
          conditions={[
            //품목코드/명
            {
              type: "input",
              name:
                props.lanData.length > 0
                  ? props.lanData.filter(
                      (f) => f.lanId === "Fom_ItemCd/Nm" && f.lanType === "FORM"
                    )[0].lanName
                  : "",
              value: props.checkInputs2.value1,
              onChange: (e) => {
                props.setCheckInputs2({
                  ...props.checkInputs2,
                  value1: e.target.value,
                });
              },
              onClick: (e) => {
                // document.getElementsByName("품목코드/명").focus;
              },
              onKeyDown: (e) => {
                props.GetMoveStockData(
                  props.checkInputs2.value1,
                  props.checkInputs2.whCd
                );
              },
            },
            //창고(조회)
            {
              type: "comboInput",
              name: "조회 창고",
              combos: props.checkInputs.comboWhCd,
              value: props.checkInputs2.whCd,
              onChange: (e) => {
                props.setCheckInputs2({
                  ...props.checkInputs2,
                  whCd: e,
                });
              },
            },
            // 창고(조회)
            {
              type: "button",
              style: {
                width: "100px",
              },
              name:
                props.lanData.length > 0
                  ? props.lanData.filter(
                      (f) => f.lanId === "Btn_Search" && f.lanType === "BTN"
                    )[0].lanName
                  : "",
              onClick: (e) => {
                props.GetMoveStockData(
                  props.checkInputs2.value1,
                  props.checkInputs2.whCd
                );
              },
            },
            // 이동할 창고
            {
              type: "comboInput",
              name: "이동 창고",

              // name:
              //   props.lanData.length > 0
              //     ? props.lanData.filter(
              //         (f) =>
              //           f.lanId === "Fom_ItemTypeNm" && f.lanType === "FORM"
              //       )[0].lanName
              //     : "",
              combos: props.checkInputs.comboMoveWhCd,
              value: props.checkInputs2.moveWhCd,
              onChange: (e) => {
                props.setCheckInputs2({
                  ...props.checkInputs2,
                  moveWhCd: e,
                });
              },
            },
          ]}
          name={
            props.lanData.length > 0
              ? props.lanData.filter(
                  (f) => f.lanId === "Fom_ItemCd/Nm" && f.lanType === "FORM"
                )[0].lanName
              : ""
          }
          onClose={() => setModalToggle2(false)}
          gridColumn={lotColumnDef}
          gridRowData={props.stockData}
          buttonName1={
            props.lanData.length > 0
              ? props.lanData.filter(
                  (f) => f.lanId === "Fom_MoveStock" && f.lanType === "FORM"
                )[0].lanName
              : ""
          }
          gridOnClick={(e) => {
            let data = [];
            for (let i = 0; i < e.length; i++) {
              data.push({
                plantCd: e[i].plantCd,
                lotNo: e[i].lotNo,
                itemCd: e[i].itemCd,
                whCd: e[i].whCd,
              });
            }
            setSelectedModalData2(data);
          }}
          execLogic={(e) => {
            props.MoveWhCdStock(selectedModalData2);
          }}
        />
      )} */}
    </div>
  );
}

export default ST10040;
